import { StreamSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import { useActiveSortChannel } from 'helpers/tracking/hooks/useActiveSortChannel'
import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { FallbackSkeleton } from 'uiComponents/molecules/ProductTile/FallbackSkeleton'
import MixedTileRowContainer from 'uiComponents/molecules/TileGrid/MixedTileRowContainer'
import { Tile } from 'uiComponents/molecules/TileGrid/RowBuilder'
import { FCRow } from 'uiComponents/molecules/TileGrid/TileGrid'
import OutfitTileConnected from './OutfitTileConnected'

const StyledRowContainer = styled(MixedTileRowContainer)`
  padding-bottom: 100px;
`

const OutfitRow: FCRow<{
  tiles: Tile[]
  rowIndex: number
  loading?: boolean
  style?: CSSProperties
  enableTadaridaTileDesign?: boolean
}> = ({ tiles, rowIndex, loading, enableTadaridaTileDesign, ...props }) => {
  const sortChannel = useActiveSortChannel()
  return (
    <StyledRowContainer data-testid="MixedTileRowContainer" {...props}>
      <StreamSectionTrackingContextProvider
        sectionIndexOnPage={rowIndex}
        sortChannel={sortChannel}
      >
        {tiles.map((tile, index) => {
          if (!tile || !tile.id) {
            return <FallbackSkeleton key={index} />
          }
          const { type, id } = tile
          switch (type) {
            case 'outfit':
              return (
                <OutfitTileConnected
                  loading={loading}
                  outfitId={id}
                  key={`outfit-${id}`}
                  disableContent={true}
                />
              )
            case 'placeholder':
            default:
              return null
          }
        })}
      </StreamSectionTrackingContextProvider>
    </StyledRowContainer>
  )
}

OutfitRow.calcHeight = ({ listWidth, tilesPerRow }) => {
  const heightConstant = 100
  return Math.round(
    (listWidth / tilesPerRow) * 1.33 - (tilesPerRow - 1) * 5 + heightConstant,
  )
}

export default OutfitRow
